/** Templates types */
export const TEMPLATES_TYPES = {
    GOOGLE_ADS_HEADLINE: 'Google Responsive Ads Headline',
    GOOGLE_ADS_DESCRIPTION: 'Google Responsive Ads Description',
    FACEBOOK_ADS: 'Facebook Ads Headline',
    FACEBOOK_ADS_DESCRIPTION: 'Facebook Ads Description',
    INSTAGRAM_ADS: 'Instagram Ads',
    CONTENT_OUTLINE: 'Content Outline',
    CONTENT_BODY: 'Content Body',
    CONTENT_TITLE_DESCRIPTION: 'Content Meta Title & Description',
    SUMMARIZE: 'Summarize Content',
    RUN_COMMAND: 'Run Command',
    FACEBOOK_POST_CONTENT: 'Facebook Post Content',
    INSTAGRAM_POST_CONTENT: 'Instagram Post Content',
    LINKEDIN_POST_CONTENT: 'LinkedIn Post Content',
    NAVER_ADS: 'Naver Ads Headline',
    NAVER_ADS_DESCRIPTION: 'Naver Ads Description',
    YAHOO_ADS: 'Yahoo Ads Headline',
    YAHOO_ADS_DESCRIPTION: 'Yahoo Ads Description',
    LINKEDIN_ADS: 'LinkedIn Ads Headline',
    LINKEDIN_ADS_DESCRIPTION: 'LinkedIn Ads Description',
    CONTENT_REWRITER: 'Content Rewriter',
    WRITE_FOR_ME: 'Write It For Me',
    YOUTUBE_TITLE_DESCRIPTION: 'YouTube Video Title & Description',
    CONTENT_IDEAS: 'Content Ideas',
    EMAIL_CONTENT: 'Email Content',
    JAPANESE_EMAIL_CONTENT: 'Japanese Email Content',
    EXPAND_TEXT: 'Expand This Text',
};
